export const chatSync = (state = false, action) => {
  if (action.type === "START_SYNC") {
    return true;
  }
  if (action.type === "RESET") {
    return false
  }
  return state
}
